import { useLocation } from "react-router-dom";

import type { IEntryPointComponent, IMasterResult } from "@/src/common/PageTransition";
import type { IUserContextResult, LoginModalView } from "@/src/contexts";
import { type ILocation } from "@/src/contexts/LocationContext";
import { useQueryPageCustom } from "@/src/query-client-factory";
import type { IFooter } from "@/src/shared/Footer/Footer";
import type { IHeader } from "@/src/shared/Header/Header";
import type { Device, IViewportInfo } from "@Components/Modules/ViewportResize";

import pages from "../pages";

export interface IMaster {
    initialData: IMasterResult;
    userData: IUserContextResult;
    url: string;
    header: IHeader;
    footer: IFooter;
    placeId: string;
    hideScrollTop: boolean;
    viewport: IViewportInfo;
    device: Device;
    loginModalView: LoginModalView | null;
    preventAuthenticationRefresh?: boolean;
    location: ILocation;
    browserOs: string;
    imageSupport: string;
    isMobileApp: boolean;
    reCaptchaPublicToken: string;
    isFriendsAndFamily: boolean;
    shouldUserSeeAds: boolean;
    cmpKey: string;
    cmpId: string;
}

export default function Master() {
    const { pathname } = useLocation();
    const query = useQueryPageCustom<IEntryPointComponent>({
        refetchOnMount: true,
    });

    const Comp = pages[query.data.component.componentName] as unknown as React.ComponentType<
        typeof query.data.component
    >;

    return <Comp {...query.data.component} key={pathname} />;
}
